import dayjs from "dayjs";

const baseDate = dayjs().startOf("day");

const invoicesDefaultFilters = {
  invoiceDateStartDate: baseDate.subtract(1, "month").toDate(),
  invoiceDateEndDate: baseDate.toDate(),
  invoiceDateType: "past30Days",
};

export default invoicesDefaultFilters;
